(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-contact"] && !Shopify.designMode) return;
  try {
    
function setupGraceContact(){document.querySelectorAll('.gp-contact-form').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';const field=form.querySelector('[data-order-field]');const message=form.querySelector('[data-message]');const count=form.querySelector('[data-message-count]');const updateTopic=()=>{const topic=form.querySelector('[data-contact-topic]:checked');if(field)field.hidden=topic?.value!=='order';};form.querySelectorAll('[data-contact-topic]').forEach(input=>input.addEventListener('change',updateTopic));if(message&&count){const updateCount=()=>{count.textContent=message.value.length+' / 2000';};message.addEventListener('input',updateCount);updateCount();}updateTopic();});}
setupGraceContact();document.addEventListener('shopify:section:load',setupGraceContact);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-launch"] && !Shopify.designMode) return;
  try {
    
function initGraceLaunch(root=document){root.querySelectorAll('[data-launch-countdown]').forEach(el=>{if(el.dataset.initialized)return;el.dataset.initialized='true';const end=Date.parse(el.dataset.launchAt);if(!Number.isFinite(end))return;let timer;const tick=()=>{if(!el.isConnected){clearInterval(timer);return}const total=Math.max(0,Math.floor((end-Date.now())/1000));const values={days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};for(const [unit,value]of Object.entries(values)){const node=el.querySelector('[data-countdown-unit="'+unit+'"]');if(node)node.textContent=String(value).padStart(2,'0')}if(total===0){el.querySelector('.gl-launch__ended').hidden=false;clearInterval(timer)}};tick();if(end>Date.now())timer=setInterval(tick,1000)})}initGraceLaunch();document.addEventListener('shopify:section:load',e=>initGraceLaunch(e.target));const launchPasswordDialog=document.querySelector('#password-form dialog');const launchPasswordButton=document.querySelector('.password-footer__button');if(launchPasswordDialog&&launchPasswordButton){launchPasswordButton.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();if(!launchPasswordDialog.open)launchPasswordDialog.showModal()});launchPasswordDialog.querySelector('.password-dialog__close-button')?.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();launchPasswordDialog.close();launchPasswordButton.focus()})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
